/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * アカウント連携種別
 * @export
 * @enum {number}
 */
export enum AccountRelationTypeEnum {
    /** アカウント登録 */
    ACCOUNT_REGISTRATION = 0,
    /** 所属追加 */
    AFFILIATION_ADDITION = 1
}

/**
 * アカウント連携種別 の Union 型
 * @export
 * @typedef AccountRelationType
 */
export type AccountRelationType =
  typeof AccountRelationTypeEnum[keyof typeof AccountRelationTypeEnum];

/**
 * アカウント連携種別 のラベルマップ
 * @export
 */
export const AccountRelationTypeLabels = {
    /**
     * 数値キー: AccountRelationTypeEnum.ACCOUNT_REGISTRATION
     * 名前キー:  ACCOUNT_REGISTRATION
     */
    [AccountRelationTypeEnum.ACCOUNT_REGISTRATION]: 'アカウント登録',
    ACCOUNT_REGISTRATION:                             'アカウント登録',
    /**
     * 数値キー: AccountRelationTypeEnum.AFFILIATION_ADDITION
     * 名前キー:  AFFILIATION_ADDITION
     */
    [AccountRelationTypeEnum.AFFILIATION_ADDITION]: '所属追加',
    AFFILIATION_ADDITION:                             '所属追加',
} as const;

/**
 * アカウント連携種別 のラベル Union 型
 * @export
 * @typedef AccountRelationTypeLabel
 */
export type AccountRelationTypeLabel =
  typeof AccountRelationTypeLabels[keyof typeof AccountRelationTypeLabels];

/**
 * アカウント連携種別 のラベル取得関数
 * @export
 * @param { AccountRelationType } value - 列挙体の値
 * @returns { AccountRelationTypeLabel } ラベル文字列
 */
export function getAccountRelationTypeLabel(
  value: AccountRelationType
): AccountRelationTypeLabel {
  return AccountRelationTypeLabels[value];
}

/**
 * アカウント連携種別 のラベル配列を取得する関数
 * @export
 * @param { AccountRelationType[] } values - 列挙体の値配列
 * @returns { AccountRelationTypeLabel[] } ラベル文字列配列
 */
export function getAccountRelationTypeLabels(values: AccountRelationType[]): AccountRelationTypeLabel[] {
  return values.map((value) => getAccountRelationTypeLabel(value));
}

/**
 * アカウント連携種別 のラベル配列
 * @export
 */
export const AccountRelationTypeLabelList = [
  'アカウント登録','所属追加',
] as const;

